import React from 'react';
import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <>
    <path d="M 8,4 C 5.7926486,4 4,5.7926486 4,8 v 8 c 0,2.207351 1.7926486,4 4,4 h 8 c 2.207351,0 4,-1.792649 4,-4 V 8 C 20,5.7926486 18.207351,4 16,4 Z m 0,1 h 8 c 1.670649,0 3,1.3293514 3,3 v 8 c 0,1.670649 -1.329351,3 -3,3 H 8 C 6.3293514,19 5,17.670649 5,16 V 8 C 5,6.3293514 6.3293514,5 8,5 Z" />
  </>,
  'CheckBoxBlank',
);
